export const featureFlagsList = {
	matching: 'MATCHING',
	vacancies: 'VACANCIES',
	userManagement: 'USER_MANAGEMENT',
	teamManagement: 'TEAM_MANAGEMENT',
	websiteManagement: 'COMPANY_WEBSITE_MANAGEMENT',
	subscription: 'SUBSCRIPTION',
	subscriptionToken: 'SUBSCRIPTION_TOKEN',
	termsAgreement: 'TERMS_AGREEMENT',
};
